import request from "@/libs/request";

import { CommonResponse } from "@/types/common";
import {
  GetCurrentUserResponse,
  GetDepartmentListResponse,
  GetEmailNotificationResponse,
  GetRoleListResponse,
  GetSearchConditionListResponse,
  GetSearchConditionLiveTextSearchResponse,
  GetSettingGroupListResponse,
  GetSettingUserListRequest,
  GetSettingUserListResponse,
  GetUserListByGroupIdResponse,
  GetGroupsWithUsersResponse,
} from "@/types/setting";
import { GetCompanyInfoResponse } from "@/types/setting";

export const GetSearchConditionLiveTextSearch = async (userName: string) =>
  request.post<CommonResponse<GetSearchConditionLiveTextSearchResponse>>(
    `/compute`,
    {
      input: `user.find_user_by_name("${userName}")`,
    }
  );

export const GetSearchConditionList = async () =>
  request.post<CommonResponse<GetSearchConditionListResponse>>(`/compute`, {
    input: `user.settings.get_search_settings()`,
  });

export const SetSearchCondition = async (params: string) =>
  request.post<CommonResponse<GetSearchConditionListResponse>>(`/compute`, {
    input: `${params}\nuser.settings.set_search_settings(request)`,
  });

export const GetCompanyInfo = () =>
  request.post<CommonResponse<GetCompanyInfoResponse>>(`/compute`, {
    input: "company.get_company_info()",
  });

export const GetSettingUserList = (params: GetSettingUserListRequest) =>
  request.post<CommonResponse<GetSettingUserListResponse>>(`/compute`, {
    input: `user.get_users(page_no=${params.page_no}, page_size=${params.page_size})`,
  });

export const GetSettingGroupList = () =>
  request.post<CommonResponse<GetSettingGroupListResponse>>(`/compute`, {
    input: `user.group.get_groups()`,
  });

export const DeleteSettingUser = (userId: string) =>
  request.post(`/compute`, { input: `user.delete_user(user_id="${userId}")` });

export const GetEmailNotification = () =>
  request.post<CommonResponse<GetEmailNotificationResponse>>(`/compute`, {
    input: `user.settings.get_email_notification_status()`,
  });

export const UpdateEmailNotification = (params: string) =>
  request.post(`/compute`, {
    input: `user.settings.update_email_notification(${params})`,
  });

export const InviteUser = (params: string) =>
  request.post(`/compute`, { input: `user.group.invite_user(${params})` });

export const GetSearchUserListByGroupIdAndName = (params: string) =>
  request.post<CommonResponse<GetSettingUserListResponse>>(`/compute`, {
    input: `user.group.find_user_by_name(${params})`,
  });

export const GetUserDepartmentList = () =>
  request.post<CommonResponse<GetDepartmentListResponse>>(`/compute`, {
    input: `user.group.get_groups()`,
  });

export const GetUserListByGroupId = (params: string) =>
  request.post<CommonResponse<GetUserListByGroupIdResponse>>(`/compute`, {
    input: `user.group.get_users(${params})`,
  });

export const AddUserToGroup = (params: string) =>
  request.post(`/compute`, { input: `user.group.add_user(${params})` });

export const DeleteUserFromGroup = (params: string) =>
  request.post(`/compute`, { input: `user.group.remove_user(${params})` });
export const AddGroup = (params: string) =>
  request.post(`/compute`, { input: `user.group.create_group(${params})` });
export const UpdateGroup = (params: string) =>
  request.post(`/compute`, { input: `user.group.rename_group(${params})` });

export const DeleteGroup = (params: string) =>
  request.post(`/compute`, { input: `user.group.delete_group(${params})` });

export const UpdateUser = (params: string) =>
  request.post(`/compute`, { input: `user.update_user(${params})` });

export const GetCurrentUser = () =>
  request.post<CommonResponse<GetCurrentUserResponse>>(`/compute`, {
    input: `auth.get_current_user()`,
  });

export const AddRole = (params: string) =>
  request.post(`/compute`, { input: `user.add_role(${params})` });

export const RemoveRole = (params: string) =>
  request.post(`/compute`, { input: `user.remove_role(${params})` });

export const GetRoleList = () =>
  request.post<CommonResponse<GetRoleListResponse>>(`/compute`, {
    input: "user.roles.get_available_roles()",
  });

export const SetRoles = (params: string) =>
  request.post(`/compute`, { input: `user.set_roles(${params})` });

export const GetGroupsWithUsers = () =>
  request.post<CommonResponse<GetGroupsWithUsersResponse>>(`/compute`, {
    input: "user.group.get_groups_with_users()",
  });
